import React, { useState, useCallback } from "react";
import Drawer from "@material-ui/core/Drawer";
import classnames from "classnames";
import useEvent from "react-use/lib/useEvent";
import { withStyles } from "@material-ui/core/styles";
import withDesignConsumer from "./withDesignConsumer";
import Paper from "@material-ui/core/Paper";

let Design;

if (process.env.DESIGNER === "yes") {
  const styles = {
    drawer: {
      display: "flex",
      flexDirection: "column"
    },
    bottom: {
      width: "100%",
      overflowX: "hidden"
    },
    right: {
      overflowX: "hidden",
      padding: "0px 0px 0px 16px"
    },
    left: {
      overflowX: "hidden",
      padding: "0px 16px 0px 0px"
    },
    top: {
      overflowX: "hidden"
    },
    wrapper: {
      bottom: 0,
      top: "auto",
      zIndex: 1299,
      overflowX: "hidden",
      background: "transparent",
      border: "0",
      height: "auto",
      maxHeight: "100vh",
      paddingRight: "4px",
      paddingBottom: "4px"
    },
    componentPaper: {
      padding: "0px 8px"
    }
  };

  Design = withStyles(styles, { name: "LcDesign" })(
    ({ classes, designers }) => {
      const [drawerOpen, setDrawerOpen] = useState(false);

      const handleKeypress = useCallback(
        e => {
          if (e.code === "Backquote" || e.keyCode === 96 || e.charCode === 96) {
            e.preventDefault();
            e.stopPropagation();
            setDrawerOpen(!drawerOpen);
          }
        },
        [setDrawerOpen, drawerOpen]
      );

      useEvent("keypress", handleKeypress);

      return (
        <Drawer
          elevation={10}
          anchor="right"
          open={drawerOpen}
          variant="persistent"
          className={classes.drawer}
          classes={{
            paper: classnames(classes.wrapper, classes.right)
          }}
        >
          {Object.entries(designers).map(
            (
              [key, { Component, props, setDesignProps, getDesignProps }],
              idx
            ) => (
              <Paper key={idx} className={classes.componentPaper} elevation={4}>
                <Component
                  setDesignProps={setDesignProps}
                  getDesignProps={getDesignProps}
                  {...props}
                />
              </Paper>
            )
          )}
        </Drawer>
      );
    }
  );
} else {
  Design = props => null;
}

export default withDesignConsumer(Design);
